module.exports = __webpack_public_path__ + "static/media/Administracion5.81b20a9.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audios/Administracion5.mp3
// module id = 712
// module chunks = 1